(() => {
  if (window.iconTooltipsInitialized) return;
  window.iconTooltipsInitialized = true;

  const tooltip = document.createElement('div');
  tooltip.className = 'icon-tooltip';
  tooltip.id = 'IconTooltip';
  tooltip.setAttribute('role', 'tooltip');
  tooltip.hidden = true;
  document.body.append(tooltip);

  let activeControl = null;
  let tapTimer = null;

  const findControl = (target) => {
    const control = target.closest?.('[data-icon-tooltip], button[aria-label], a[aria-label], [role="button"][aria-label]');
    if (!control) return null;
    if (!control.dataset.iconTooltip && !control.querySelector('svg, img')) return null;
    return control;
  };

  const tooltipText = (control) => control.dataset.iconTooltip || control.getAttribute('aria-label') || '';

  const positionTooltip = (control) => {
    const controlBox = control.getBoundingClientRect();
    const tooltipBox = tooltip.getBoundingClientRect();
    const halfWidth = tooltipBox.width / 2;
    const center = Math.min(window.innerWidth - halfWidth - 8, Math.max(halfWidth + 8, controlBox.left + controlBox.width / 2));
    const fitsAbove = controlBox.top >= tooltipBox.height + 14;
    tooltip.style.left = `${center}px`;
    tooltip.style.top = fitsAbove
      ? `${controlBox.top - tooltipBox.height - 8}px`
      : `${controlBox.bottom + 8}px`;
  };

  const show = (control) => {
    const text = tooltipText(control);
    if (!text) return;
    if (activeControl && activeControl !== control) activeControl.removeAttribute('aria-describedby');
    activeControl = control;
    control.setAttribute('aria-describedby', tooltip.id);
    tooltip.textContent = text;
    tooltip.hidden = false;
    positionTooltip(control);
    requestAnimationFrame(() => tooltip.classList.add('is-visible'));
  };

  const hide = () => {
    window.clearTimeout(tapTimer);
    activeControl?.removeAttribute('aria-describedby');
    activeControl = null;
    tooltip.classList.remove('is-visible');
    window.setTimeout(() => {
      if (!activeControl) tooltip.hidden = true;
    }, 130);
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const control = findControl(event.target);
    if (control) show(control);
  });

  document.addEventListener('pointerout', (event) => {
    if (!activeControl || activeControl.contains(event.relatedTarget)) return;
    if (activeControl === findControl(event.target)) hide();
  });

  document.addEventListener('focusin', (event) => {
    const control = findControl(event.target);
    if (control) show(control);
  });

  document.addEventListener('focusout', (event) => {
    if (activeControl === findControl(event.target)) hide();
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;
    const control = findControl(event.target);
    if (!control) return;
    show(control);
    window.clearTimeout(tapTimer);
    tapTimer = window.setTimeout(hide, 1800);
  });

  document.addEventListener('click', (event) => {
    const control = findControl(event.target);
    if (!control || control !== activeControl) return;
    queueMicrotask(() => {
      if (activeControl === control) show(control);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide();
  });

  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
})();
